import { render, staticRenderFns } from "./DomainMaintenance.vue?vue&type=template&id=5e0dcff2&lang=pug"
import script from "./DomainMaintenance.vue?vue&type=script&lang=js"
export * from "./DomainMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0dcff2')) {
      api.createRecord('5e0dcff2', component.options)
    } else {
      api.reload('5e0dcff2', component.options)
    }
    module.hot.accept("./DomainMaintenance.vue?vue&type=template&id=5e0dcff2&lang=pug", function () {
      api.rerender('5e0dcff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/configuration/DomainMaintenance.vue"
export default component.exports